import { createGlobalModal } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';
import type { FormInputs } from './CompanyDetailsForm/CompanyDetailsForm';
import { CompanyDetailsModal } from './CompanyDetailsModal';

export { CompanyDetailsModal } from './CompanyDetailsModal';

export const openCompanyDetailsModal = createGlobalModal<void, FormInputs, Error>(
  CompanyDetailsModal,
);
